import React from "react";
import Paper from "@mui/material/Paper";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import TransferStatusBanner from "./TransferStatusBanner";
import TransferVolumeChart from "./TransferVolumeChart";
import { surfaceSx } from "./transferTheme";
import { SAVED_BANNER_MS } from "./transferMath";
import useNow from "./useNow";

export function shouldShowLiveTransferCard({ session, lastSaved, audit, now }) {
  if (session?.status === "active" || session?.status === "saving") return true;
  if (audit?.manualCaptureMissing) return true;
  return Boolean(lastSaved && now - lastSaved.savedAt < SAVED_BANNER_MS);
}

export default function LiveTransferCard({ session, lastSaved, audit, isLive, lastUpdated, capacity, onOpenMonitor }) {
  const now = useNow(1000);
  if (!shouldShowLiveTransferCard({ session, lastSaved, audit, now })) return null;

  const samples = session?.samples?.length
    ? session.samples
    : lastSaved ? session?.completedSamples?.[lastSaved.transfer.id] ?? [] : [];

  return (
    <Paper elevation={0} sx={(theme) => ({ ...surfaceSx(theme), mb: 3, p: { xs: 2, md: 2.5 } })}>
      <TransferStatusBanner
        session={session}
        lastSaved={lastSaved}
        audit={audit}
        isLive={isLive}
        lastUpdated={lastUpdated}
        now={now}
        compact
      />
      <MDBox mt={2}>
        <TransferVolumeChart
          samples={samples}
          baseline={session?.baseline ?? lastSaved?.transfer?.startGallons}
          capacity={capacity}
          direction={session?.direction ?? lastSaved?.transfer?.type}
          height={140}
        />
      </MDBox>
      <MDBox display="flex" justifyContent="flex-end" mt={1.5}>
        <MDButton size="small" variant="gradient" color="info" onClick={onOpenMonitor}>
          <i className="fa-solid fa-up-right-and-down-left-from-center" style={{ marginRight: 8 }} />
          Open monitor
        </MDButton>
      </MDBox>
    </Paper>
  );
}
